import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';

@Component({
  standalone: false,
  selector: 'sbnb-the-host-co',
  template: `
    <sbnb-apps-detail-page
      vendorCode="thehostco"
      name="The Host Co."
      logoTile="/assets/images/apps/hostco.png"
      builtBy="The Host Co."
      builtByLink="https://thehost.co"
      [categories]="['Amenities']"
      [permissions]="[AppPermission.propertyListingRead, AppPermission.enrichmentRead, AppPermission.upsellShortcode]"
      email="support@thehost.co"
      [helpLink]="{ text: 'Book a Demo with The Host Co.', href: 'https://thehost.co/get-started' }"
      [helpArticles]="[
        {
          id: '9246881',
          title: 'Connecting Hospitable with The Host Co.'
        }
      ]">
      <!-- <iframe
        style="border-radius: 12px"
        width="100%"
        height="600"
        src="https://www.youtube.com/embed/pAdyEKL_lR8?si=BXYqLVlupH8AHw-6"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen></iframe> -->
      <div class="video-container">
        <iframe
          style="border-radius: 12px"
          width="100%"
          height="600"
          src="https://www.youtube.com/embed/pAdyEKL_lR8?si=BXYqLVlupH8AHw-6"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen></iframe>
      </div>
      <ng-container description>
        <p>
          Instantly offer hotel-level amenities in your rentals with a digital storefront and add up to 30% more revenue
          per booking.
        </p>

        <p>
          Your storefront can be customized to your exact listing and include curated local services like massage and
          chef, alterations like late checkout and pool heating, and on-site sales, rentals, luggage storage and beyond.
          Each upsell improves guest experience and adds a brand new revenue stream to your rentals.
        </p>

        <p>
          The Host Co takes care of bespoke store creation, messaging, scheduling, payments, vendor curation & vetting,
          fullfillment and more.
        </p>
      </ng-container>
    </sbnb-apps-detail-page>
  `,
  styleUrls: ['./the-host-co.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TheHostCoComponent {
  AppPermission = AppPermission;
}
